export default __webpack_public_path__ + "static/media/logo.6bb1e556.svg";